// src/components/image.jsx
import React from "react";

export const Image = ({ title, smallImage, onClick }) => (
  <div className="portfolio-item">
    <div className="hover-bg" role="button" tabIndex={0} onClick={onClick}>
      <div className="hover-text">
        <h4>{title}</h4>
      </div>
      <img src={smallImage} className="img-responsive-spec" alt={title} />
    </div>
  </div>
);
